import React from 'react';
import Icon from '../../common/Icons';
import { getPasswordChecks, isPasswordStrong } from '../../../utils/passwordPolicy';

export default function PasswordRequirements({
  password = '',
  confirmPassword = '',
  showConfirmMatch = false,
  active = true
}) {
  const checks = getPasswordChecks(password);
  const hasInput = String(password).length > 0;
  const allMet = isPasswordStrong(password);
  const confirmFilled = String(confirmPassword).length > 0;
  const passwordsMatch = password === confirmPassword && confirmFilled;

  if (!active) return null;

  return (
    <div
      className={`adm-pwd-reqs ${hasInput ? (allMet ? 'adm-pwd-reqs--valid' : 'adm-pwd-reqs--typing') : ''}`}
      aria-live="polite"
    >
      <p className="adm-pwd-reqs__title">Critères du mot de passe</p>
      <ul className="adm-pwd-reqs__list">
        {checks.map((rule) => {
          const state = !hasInput ? 'idle' : rule.ok ? 'ok' : 'ko';
          return (
            <li key={rule.id} className={`adm-pwd-reqs__item adm-pwd-reqs__item--${state}`}>
              <span className="adm-pwd-reqs__icon" aria-hidden>
                {state === 'ok' ? (
                  <Icon name="checkCircle" size={14} />
                ) : state === 'ko' ? (
                  <Icon name="times" size={12} />
                ) : (
                  <span className="adm-pwd-reqs__dot" />
                )}
              </span>
              <span>{rule.label}</span>
            </li>
          );
        })}
      </ul>

      {showConfirmMatch && confirmFilled && (
        <p
          className={`adm-pwd-reqs__match ${passwordsMatch ? 'adm-pwd-reqs__match--ok' : 'adm-pwd-reqs__match--ko'}`}
        >
          <Icon name={passwordsMatch ? 'checkCircle' : 'exclamationCircle'} size={14} />
          <span>
            {passwordsMatch ? 'Les mots de passe correspondent' : 'Les mots de passe ne correspondent pas'}
          </span>
        </p>
      )}
    </div>
  );
}
